import React from 'react';
import { RotateCcw } from 'lucide-react';

interface HeaderProps {
    showNav?: boolean;
    pageIndex?: number;
    totalPages?: number;
    onReset?: () => void;
}

import { LOGO_BASE64 } from '../assets/logoData';

const Logo = ({ className }: { className?: string }) => (
    <img
        src={LOGO_BASE64}
        alt="קארן אבנם"
        className={`${className} object-contain`}
    />
);

const Header: React.FC<HeaderProps> = ({ showNav, pageIndex, totalPages, onReset }) => {
    return (
        <header className="relative bg-brand-dark pt-8 pb-10 sm:pb-16 flex-shrink-0">
            <div className="max-w-3xl mx-auto px-4 relative z-10">
                <div className="flex justify-between items-start">
                    {/* Page Count */}
                    <div className="w-1/3 text-right text-xs sm:text-sm text-white/60 font-light tracking-wide pt-4">
                        {showNav && totalPages !== undefined && pageIndex !== undefined && (
                            `עמוד ${pageIndex + 1} מתוך ${totalPages}`
                        )}
                    </div>

                    {/* Logo */}
                    <div className="w-1/3 flex justify-center">
                        <div className="text-center flex flex-col items-center justify-center">
                            <a href="https://karenavnam.com/" target="_blank" rel="noopener noreferrer" className="transition-transform hover:scale-105 block">
                                <Logo className="h-14 sm:h-20 w-auto" />
                            </a>
                        </div>
                    </div>

                    {/* Reset Button */}
                    <div className="w-1/3 flex justify-end">
                        {onReset && (
                            <button
                                onClick={onReset}
                                className="group flex items-center gap-2 text-white/50 hover:text-white transition-all duration-300 pt-4"
                                title="אפס שאלון"
                            >
                                <RotateCcw className="w-4 h-4 group-hover:-rotate-180 transition-transform duration-500" />
                                <span className="text-xs sm:text-sm hidden sm:inline">איפוס</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {/* Wave Border SVG */}
            <div className="absolute bottom-[-1px] left-0 w-full overflow-hidden leading-[0]">
                <svg
                    className="relative block w-full h-[25px] sm:h-[40px]"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1200 120"
                    preserveAspectRatio="none"
                >
                    <path
                        d="M0,120 L0,0 C350,60 700,110 1200,115 L1200,120 Z"
                        fill="#ffffff"
                    ></path>
                </svg>
            </div>
        </header>
    );
};

export default Header;
